import type {
  HashtagCampaign,
  HashtagCampaignCatalogItem,
  HashtagPlatformRow,
  HashtagRead,
} from '@/types/hashtag.types';
import { normalizeHashtagPlatformCode } from './hashtagUtils';

function platformRowFromRead(row: HashtagRead): HashtagPlatformRow | null {
  const id = String(row.id ?? '').trim();
  const hashtag_campaign_code = String(row.hashtag_campaign_code ?? '').trim();
  const platform_code = normalizeHashtagPlatformCode(String(row.platform_code ?? ''));
  if (!id || !hashtag_campaign_code || !platform_code) return null;

  return {
    id,
    hashtag_campaign_code,
    name: String(row.name ?? hashtag_campaign_code).trim() || hashtag_campaign_code,
    platform_code,
    is_active: row.is_active !== false,
    created_at: row.created_at,
  };
}

function normalizePlatformRow(row: HashtagPlatformRow): HashtagPlatformRow {
  return {
    ...row,
    platform_code: normalizeHashtagPlatformCode(row.platform_code),
  };
}

/** Normaliza campaña del GET agrupado. */
export function normalizeHashtagCampaign(campaign: HashtagCampaign): HashtagCampaignCatalogItem {
  return {
    hashtag_campaign_code: campaign.hashtag_campaign_code,
    name: campaign.name,
    platforms: (campaign.platforms ?? []).map(normalizePlatformRow),
    scraping_status: campaign.scraping_status ?? null,
    last_scraped_at: campaign.last_scraped_at ?? null,
  };
}

export function normalizeHashtagCampaignList(
  campaigns: HashtagCampaign[]
): HashtagCampaignCatalogItem[] {
  return campaigns.map(normalizeHashtagCampaign);
}

/** Agrupa filas planas (POST 201 legacy) en campañas. */
export function groupHashtagReadsToCampaigns(rows: HashtagRead[]): HashtagCampaignCatalogItem[] {
  const byCode = new Map<string, HashtagCampaignCatalogItem>();

  for (const row of rows) {
    const platform = platformRowFromRead(row);
    if (!platform) continue;

    let campaign = byCode.get(platform.hashtag_campaign_code);
    if (!campaign) {
      campaign = {
        hashtag_campaign_code: platform.hashtag_campaign_code,
        name: platform.name,
        platforms: [],
      };
      byCode.set(platform.hashtag_campaign_code, campaign);
    }

    campaign.platforms.push(platform);
  }

  return Array.from(byCode.values());
}
